export default {
    data() {
        return {

        }
    },
    computed: {

    },
    watch: {
    },

    created() {
    },
    mounted() {
    },
    methods: {
        onStartDragged(e) {
            this.updateOnStartDragged(e)
        },
        onEndDragged(e) {
            this.updateOnEndDragged(e)
        },
        onSelectedDragged(e) {
            this.updateOnSelectedDragged(e)
        },

        onStartDraggable(e) {
            this.updateOnStartDraggable(e)
        },
        onEndDraggable(e) {
            this.updateOnEndDraggable(e)
        },
        onSelectedDraggable(e) {
            this.updateOnSelectedDraggable(e)
        },

       updateOnStartDraggable(e) {
            this.$emit('start:before', this.calc(), e)
        },
        updateOnStartDragging(e) {
            this.$emit('start:changing', this.calc(), e)
        },
        updateOnStartDragged(e) {
            this.$emit('start:changed', this.calc(), e)
        },

        updateOnEndDraggable(e) {
            this.$emit('end:before', this.calc(), e)
        },
        updateOnEndDragging(e) {
            this.$emit('end:changing', this.calc(), e)
        },
        updateOnEndDragged(e) {
            this.$emit('end:changed', this.calc(), e)
        },

        updateOnSelectedDraggable(e) {
            this.$emit('selected:before', this.calc(), e)
        },
        updateOnSelectedDragging(e) {
            this.$emit('selected:changing', this.calc(), e)
        },
        updateOnSelectedDragged(e) {
            this.$emit('selected:changed', this.calc(), e)
        },

        scaleResized({width}) {
            if (width !== this.originalScaleWidth) {
                const {start, end} = this.dCalc(width)
                this.updateStartPosition(this.els.start, this.els.context, start, 0)
                this.updateEndPosition(this.els.end, this.els.context, end, 0)
                this.updateTimeDisplay()

                this.originalScaleWidth = width
            }

        }

    }
}
